import React from 'react';
import styles from './AnaValue.module.css';

const values = [
  {
    icon: '🚀',
    title: 'ROI in weeks',
    description: 'Immediate value and return on investment.'
  },
  {
    icon: '✨',
    title: 'Quality and Scalability',
    description: 'Maintain high standards while scaling your development operations'
  },
  {
    icon: '💡',
    title: 'Innovation and What\'s Next',
    description: 'Accelerate Innovation and focus on defining What\'s Next'
  },
  {
    icon: '📈',
    title: 'Up to 5x productivity gain',
    description: 'Significantly boost your team\'s development efficiency'
  }
];

const AnaValue: React.FC = () => {
  return (
    <section className={styles.section} id="value">
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Ana Value</h2>
          <p className={styles.subtitle}>
            Discover the unique advantages that set Ana apart
          </p>
        </div>

        <div className={styles.valueGrid}>
          {values.map((value, index) => (
            <div key={index} className={styles.valueCard}>
              <div className={styles.iconWrapper}>
                <span className={styles.icon}>{value.icon}</span>
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AnaValue;
